export const wdOpportunityInfoColumns = [
  '_id',
  'dataLakeId',
  'revintId',
  'workDriverDetails.actionId',
  'workDriverDetails.actionName',
  'workDriverDetails.categoryName',
  'opportunityTasks',
  'consolidatedEventLog',
  'isHighDollar',
  'isRush',
  'userCalculatedOpportunityValue',
  'userCalculatedOpportunityXR',
  'userCalculatedDueDate',
  'userCalculatedPricingNotes',
  'userCalculatedPaymentVariance',
  'isEndState',
  'isEndStateDate',
  'isManuallyCreated',
  'isStopReprocessing',
  'accountPaymentTrigger',
  'accountPaymentTriggerDate',
  'lastModifiedDate',
  'opportunityTaskStatus',
  'accountNumber',
  'r1Id',
  'filtered',
  'isOOS',
  'isSuppressed',
  'isOpportunity',
  'opportunityXR',
  'clientExpected',
  'arBalance',
  'correlationId',
  'medicareXR',
  'ruleDescription',
  'isQueueAssignedBefore',
  'pricingNotes',
];
